<template>
    <nav
        class="pt-1 select-none"
        aria-label="Filter"
    >
        <div
            class="wrapper relative flex w-full flex-row flex-wrap items-start justify-start gap-2 rounded-md py-0.5"
        >
            <div
                v-for="tag in tags"
                :key="tag.tagId"
                class="flex items-center justify-center rounded-sm border px-2 py-0.5 text-xs font-medium"
                :style="createTagStyle(tag.color || defaultColor)"
            >
                <span class="-mt-px">{{ tag.name }}</span>
            </div>
        </div>
    </nav>
</template>

<script setup>
import { createTagStyle, validateHexColor, getDefaultColor } from '../composables/useColor';
import { cloneData } from '../composables/utils';

defineExpose({
    name: 'TagShow',
});

const props = defineProps({
    tags: {
        type: Array,
        default: () => {
            return [];
        },
    },
});

const defaultColor = getDefaultColor();

const tags = cloneData(props.tags);

const normalizeTags = () => {
    tags.map((item, index) => {
        if (item.tag) {
            tags[index] = item.tag;
        }
        if (tags[index].color === null || validateHexColor(tags[index].color) === false) {
            tags[index].color = defaultColor;
        }
    });
};

normalizeTags();
</script>
